import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API, useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const hasProcessed = useRef(false);
  const [status, setStatus] = useState("Finalizing sign-in...");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login");
      return;
    }
    const sessionId = match[1];

    (async () => {
      try {
        const res = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        const token = res.data.session_token;
        if (token) localStorage.setItem("spv_session_token", token);
        await checkAuth();
        const user = res.data.user;
        // clear hash
        window.history.replaceState(null, "", window.location.pathname);
        if (!user.role) navigate("/onboarding", { replace: true });
        else if (user.role === "farmer") navigate("/farmer", { replace: true });
        else if (user.role === "buyer") navigate("/buyer", { replace: true });
        else if (user.role === "admin") navigate("/admin", { replace: true });
        else navigate("/", { replace: true });
      } catch (e) {
        setStatus("Sign-in failed. Redirecting...");
        setTimeout(() => navigate("/login"), 1500);
      }
    })();
  }, [navigate, checkAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center hero-gradient" data-testid="auth-callback">
      <div className="glass rounded-2xl px-10 py-8 text-center">
        <div className="w-10 h-10 mx-auto border-2 border-saffron/30 border-t-saffron rounded-full animate-spin" />
        <p className="mt-4 text-cream text-sm">{status}</p>
      </div>
    </div>
  );
}
